import cx from 'classnames';
import Image from 'next/image';

import {Icon} from '#component/base/Icon';
import {Text} from '#component/base/Text';
import {sprinkles} from '#style/sprinkles';

import {InfoHeaderProps} from './InfoHeader.types';

import * as css from './InfoHeader.css';

const InfoCard = ({className = ''}) => (
  <div
    className={cx(
      sprinkles({
        bg: 'paleOrange',
        content: 'start',
        gap: 24,
        flex: 'flex',
        items: 'start',
        p: [16, 32, 24],
        radius: 8,
      }),
      className,
    )}>
    <div className={sprinkles({bg: 'white', p: 8, radius: 'circle'})}>
      <Icon name="TestTube" color="burgundy" size={24} />
    </div>

    <div className={sprinkles({flex: 'flex', dir: 'col', gap: 4})}>
      <Text as="h4" variant="body" color="burgundy" fontWeight="semiBold">
        Did you know?
      </Text>

      <Text as="p" variant="body" color="mineShaft">
        Our Tally Health dataset is the largest DNA methylation adult cheek swab dataset ever
        generated.
      </Text>
    </div>
  </div>
);

export const InfoHeader = ({
  firstParagraph,
  highlightedText,
  imageUrl,
  secondParagraph,
  showInfoCard,
  thirdParagraph,
  title,
}: InfoHeaderProps) => {
  return (
    <div className={sprinkles({layout: 'grid', pY: [72, 144]})}>
      <div className={sprinkles({colSpan: [4, 6], colStart: [1, 2], pR: [0, 0, 48]})}>
        <Text variant="heading1" as="h1" color="deepBurgundy" className={sprinkles({mB: [48, 64]})}>
          {title}
        </Text>

        <div className={sprinkles({display: 'flex', direction: 'col', gap: [24, 32]})}>
          <Text variant="bodyLarge" as="p" color="mineShaft">
            {firstParagraph}
          </Text>

          <div className={css.innerImage}>
            <Image aria-hidden alt="" src={imageUrl} layout="fill" objectFit="cover" />
          </div>

          <Text variant="bodyLarge" as="p" color="mineShaft">
            {secondParagraph}
          </Text>

          {showInfoCard && <InfoCard className={sprinkles({flex: ['flex', 'flex', 'none']})} />}

          {thirdParagraph && (
            <Text variant="bodyLarge" as="p" color="mineShaft">
              {thirdParagraph}
            </Text>
          )}

          <Text variant="bodyLarge" as="p" color="eggplantDark">
            {highlightedText}
          </Text>
        </div>
      </div>

      <div
        className={sprinkles({
          colSpan: [4, 6, 5],
          colStart: [1, 2, 8],
          dir: 'col',
          flex: ['none', 'none', 'flex'],
          gap: 128,
          pos: 'relative',
          z: 0,
        })}>
        <div className={css.imageContainer}>
          <Image
            aria-hidden
            alt=""
            className={css.imageDesktop}
            src={imageUrl}
            layout="fill"
            objectFit="cover"
          />
        </div>

        {showInfoCard && <InfoCard />}
      </div>
    </div>
  );
};
